import { Component, OnInit } from "@angular/core";
import { AppService } from "./app.service";
import * as CryptoJS from "crypto-js";
import { environment } from "src/environments/environment";
import firebase from "firebase";
import { TranslateService } from "@ngx-translate/core";
import { ConnectionService } from "ng-connection-service";
import { ToastrService } from "ngx-toastr";
import { Title } from "@angular/platform-browser";
import { StripeScriptTag } from "stripe-angular";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  baseData = {};
  oneSignalData = {};
  constructor(
    private service: AppService,
    private translate: TranslateService,
    private connection: ConnectionService,
    private toastr: ToastrService,
    private titleService: Title,
    private stripeScriptTag: StripeScriptTag
  ) {
    stripeScriptTag.setPublishableKey(environment.publicKey);

    this.translate.onLangChange.subscribe((e: any) => {
      this.titleService.setTitle(e.translations.PAGE_TITLE);
    });
    if (localStorage.getItem("localStorageLangKey")) {
      const language = JSON.parse(localStorage.getItem("localStorageLangKey"));
      this.translate.setDefaultLang(language);
    } else {
      this.translate.setDefaultLang("en");
    }

    this.connection.monitor().subscribe((isConnected) => {
      if (!isConnected) {
        this.toastr.error("CONNECTION REFUSED", "OOPS!", {
          closeButton: false,
          disableTimeOut: true,
          tapToDismiss: false,
        });
      } else {
        toastr.clear();
      }
    });
  }

  ngOnInit(): void {
    localStorage.removeItem(environment.pagesLocalStorageKey);
    localStorage.removeItem(environment.videoStorage);
    var firebaseConfig = {
      apiKey: "AIzaSyC0TTIHRTNeLRgltyVTSURkKZGKSKo8YW0",
      authDomain: "intelligens-438fd.firebaseapp.com",
      projectId: "intelligens-438fd",
      storageBucket: "intelligens-438fd.appspot.com",
      messagingSenderId: "416603137573",
      appId: "1:416603137573:web:528b3e9e991090c09541cc",
      measurementId: "G-XFRTX6C87T",
    };
    // firebase.initializeApp(firebaseConfig);
    // firebase.analytics();
    this.service.baseApi().subscribe((data: any) => {
      if (data) {
        this.baseData = data;
        const baseData = CryptoJS.AES.encrypt(
          JSON.stringify(this.baseData),
          environment.secretkey
        ).toString();
        localStorage.setItem("baseData", baseData);
      }
    });
    const OneSignal = window["OneSignal"] || [];
    OneSignal.push(() => {
      OneSignal.on("subscriptionChange", () => {
        OneSignal.push(() => {
          OneSignal.getUserId(function (userId) {
            const data = { id: userId };
            const oneSignalData = CryptoJS.AES.encrypt(
              JSON.stringify(data),
              environment.secretkey
            ).toString();
            localStorage.setItem("oneSignalData", oneSignalData);
          });
        });
      });
    });
    OneSignal.getUserId().then((userId) => {
      const data = { id: userId };
      const oneSignalData = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        environment.secretkey
      ).toString();
      localStorage.setItem("oneSignalData", oneSignalData);
    });
    OneSignal.push(() => {
      // Occurs when the user's subscription changes to a new value.
      OneSignal.getUserId().then((userId) => {
        const data = { id: userId };
        const oneSignalData = CryptoJS.AES.encrypt(
          JSON.stringify(data),
          environment.secretkey
        ).toString();
        localStorage.setItem("oneSignalData", oneSignalData);
      });
    });
  }
  // getOneSignalData(userId) { }
}
